## JMX

The JMX plugin gives a raw view of the underlying JMX metric data, allowing access to the entire JMX domain tree of MBeans.
